import React, { useRef, useCallback } from 'react';

import { Popup, usePopup } from '@tmapy/style-guide';

import { LogoutBtn } from '../../auth/components/LogoutBtn';
import { UpdateUserBtn } from '../../auth/components/UpdateUserBtn';
import { useAuth, useSelector } from '../../hooks';

import './UserInfo.sass';

const popupPosition = ['right-center' as const, 'right-bottom' as const, 'right-top' as const];

export const UserInfo: React.FC = () => {
  const auth = useAuth();
  const { auth: authConfig, hideLogoutBtn } = useSelector((state) => state.app.config);

  const popupTriggerRef = useRef<HTMLButtonElement>(null);
  const popupContentRef = useRef<HTMLParagraphElement>(null);
  const [isPopupShown, setPopupShown] = usePopup(popupTriggerRef, popupContentRef);

  const handleClick = useCallback(() => {
    setPopupShown(!isPopupShown);
  }, [isPopupShown, setPopupShown]);

  const isPopup = authConfig ? authConfig && !hideLogoutBtn : true;

  return (
    <>
      <button
        ref={popupTriggerRef}
        className='dmx-userInfo sg-a-d-f sg-a-ai-c'
        type='button'
        onClick={handleClick}
      >
        <div className='dmx-userInfo--avatar sg-a-f-n'>
          {auth.name[0]}
          {auth.surname[0]}
        </div>
        <div className='sg-a-ml-1'>
          <div className='dmx-userInfo--name'>
            {auth.name} {auth.surname}
          </div>
          <div className='dmx-userInfo--role'>
            {auth.roles?.map((role) => (
              <React.Fragment key={role.id}>{role.label}</React.Fragment>
            ))}
          </div>
        </div>
      </button>
      {isPopup && isPopupShown && (
        <Popup triggerRef={popupTriggerRef} position={popupPosition}>
          <p ref={popupContentRef} className='sg-a-p-1 sg-a-d-f sg-a-fd-c sg-a-g-1'>
            {authConfig ? <LogoutBtn /> : <UpdateUserBtn />}
          </p>
        </Popup>
      )}
    </>
  );
};
